export default "__VITE_ASSET__IWRECM91__"